import { httpInternalAppService } from '@/modules/common/services';

const baseRoute = 'apps/documents';

const createDocumentUrls = async (activityUids) => {
  let result;
  try {
    result = await httpInternalAppService.get(`${baseRoute}/bulk/direct-url`, {
      action: 'download',
      activity_uids: activityUids
    });
    result = result.data;
  } catch (error) {
    result = { code: 'error' };
    console.error(error);
  }

  return result;
};

export default {
  createDocumentUrls,
};
